/**
 * This ModuleLoader calls the init() methods on each module added to the object in app.js
 */
class ModuleLoader {
	constructor(modules) {
		this.modules = modules;
	}

	init() {
		const modules = this.modules;
		Object.keys(modules).forEach(function(key) {
			modules[key].init();
		});
	}
}

export default ModuleLoader;
